export function ObserverFooter() {
  let isIntersected = false;
  const footer = document.querySelector("#footer__paco");
  const fixedMessage = document.querySelector(".stickyGame");
  let options = {
    threshold: 0.2,
  };

  if (!fixedMessage) return

  let observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        fixedMessage.classList.add("noShow");
        isIntersected = true;
      } else if (isIntersected == true) {
        fixedMessage?.classList.remove("noShow");
      }
    });
  }, options);

  observer.observe(footer);
}

// export function ObserverHeader() {
//   let isIntersected = false;
//   const header = document.querySelector("header.header");
//   const fixedMessage = document.querySelector(".stickyGame") as HTMLElement;
//   let options = {
//     rootMargin: "600px 0px 0px 0px"
//   };

//   if(window.innerWidth <= 820) return

//   if (fixedMessage && header) {
//     let observer = new IntersectionObserver((entries, observer) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting && window.innerWidth >= 820) {
//           fixedMessage.style.bottom = "30%";
//           isIntersected = true;
//         } else if (isIntersected == true && window.innerWidth >= 820) {
//           fixedMessage.style.bottom = "3%";
//         } else{
//           fixedMessage.style.bottom = "0";
//         }
//       });
//     }, options);

//     observer.observe(header);
//   }
// }

export function stickyClose() {
  const stickyGame = document.querySelector(".stickyGame");
  const closeBtn = document.querySelector(".stickyGame_icon-closed");
  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      stickyGame.classList.add("noShow");
    });
  }
}
